import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/CnpjPage.css";

const CnpjPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Portal do Cliente - Acesso CNPJ";
  }, []);

  return (
    <div className="cnpj-container">
      <div className="cnpj-card">
        <div className="cnpj-app-title">Portal do Cliente</div>

        <h2>Acesso para clientes com CNPJ</h2>

        <p className="cnpj-text">
          Se você possui um número de CNPJ, entre em contato conosco através do endereço de e-mail abaixo para que possamos ajudar a resolver o problema.
        </p>

        <div className="cnpj-email-box">
          <a href="mailto:contato@pogustgoodhead.com">
            contato@pogustgoodhead.com
          </a>
        </div>

        <button
          type="button"
          className="cnpj-back-button"
          onClick={() => navigate("/signin")}
        >
          Voltar para o login
        </button>
      </div>
    </div>
  );
};

export default CnpjPage;